<template>
  <div class="constrain pt-2 lg:pt-24">
    <div class="flex flex-col lg:flex-row justify-between items-center">
      <KnowledgeHeader :title="blok.title" />

      <div class="w-full lg:w-[460px] mt-4 lg:mt-0">
        <KnowledgeSearchArticles />
      </div>
    </div>

    <div class="flex flex-col lg:flex-row mt-4 lg:mt-16">
      <KnowledgeCategoryList
        :class="{ 'hidden lg:block': blok.category }"
      />

      <KnowledgeArticleGrid
        :category="props.blok.category"
        :class="{ 'hidden lg:block': !blok.category }"
      />
    </div>

    <div class="text-center mt-10 lg:mt-20 mb-10">
      <h4 class="subtitle-1">Still have questions</h4>
      <div class="mt-2 lg:mt-6 text-grey-dark font-normal text-base">
        You can send us message, call or chat live with an expert for personalised advice.
      </div>
      <Button class="mt-6" as="nuxt-link" to="/contact-us" size="lg">Contact us</Button>
    </div>
  </div>

  <div class="frame z-0 hidden lg:block">
    <div class="circle"></div>
  </div>
</template>

<script setup>
const props = defineProps({
  blok: Object,
});

const route = useRoute();

useHead({
  link: [
    {
      rel: 'canonical',
      href: `https://justhire.com${route.path}`
    }
  ]
});

let url = `knowledge`;
if (props.blok.category) {
  url = `knowledge/c/${props.blok.category}`;
}

// Fetch the story for SEO purposes
const story = await useAsyncStoryblok(url, {
  version: useRuntimeConfig().public.storyblokVersion,
});

const knowledgeStore = useKnowledgeStore();
knowledgeStore.setCategory(props.blok.category);

// Set SEO metadata using the fetched story
useSeoMeta({
  title: () => story.value?.content?.metatags?.title || 'Knowledge Base | Helpful Guides | JustHire',
  description: () => story.value?.content?.metatags?.description || 'Discover our comprehensive knowledge base filled with expert articles, guides, and resources to help you find answers and solutions quickly and easily.',
});
</script>
<style scoped>
/* Styles for the frame */
.frame {
  position: absolute;
  z-index:-1;
  left: -300px;
  top: 400px;
  width: 1200px;
  height: 1200px;
  margin: 50px auto;
  overflow: hidden;
}

/* Styles for the circle */
.circle {
  position: relative;
  top:100px;
  width: 945px;
  height: 945px;
  border-radius: 50%;
  background:
    radial-gradient(circle,
    rgba(95, 20, 225, 0.5) 0%,
    rgba(95, 20, 225, 0.35) 40%,
    rgba(95, 20, 225, 0.15) 70%,
    rgba(95, 20, 225, 0) 100%
    );
  filter: blur(100px);
  opacity: 0.2;
}

/* Tablet view */
@media (max-width: 1024px) {
  .frame {
    width: 300px;
    height: 300px;
    margin: 30px auto;
  }

  .circle {
    top: 80px;
    left: 80px;
    width: 300px;
    height: 300px;
  }
}

/* Mobile view */
@media (max-width: 768px) {
  .frame {
    width: 200px;
    height: 200px;
    margin: 10px auto;
  }

  .circle {
    top: 50px;
    left: 50px;
    width: 200px;
    height: 200px;
  }
}
</style>
